document.addEventListener('DOMContentLoaded', (e) => {
	// US Extremists
	if (document.querySelector('#faisal-tab-us')) {
		jQuery(once('us','#faisal-tab-us'))
			.click(function (e) {
				e.preventDefault();
				jQuery('.view-display-id-block_us').triggerHandler('RefreshView');
				jQuery('#faisal-tab-uk').removeClass('selected');
				jQuery('#faisal-tab-major').removeClass('selected');
				jQuery(this).addClass('selected');
				jQuery('#grid-faisal-tab-us').show();
				jQuery('#grid-faisal-tab-uk').hide();
				jQuery('#grid-faisal-tab-major').hide();
			});
	}

	// UK Extremists
	if (document.querySelector('#faisal-tab-uk')) {
		jQuery(once('uk','#faisal-tab-uk'))
			.click(function (e) {
				e.preventDefault();
				jQuery('.view-display-id-block_uk').triggerHandler('RefreshView');
				jQuery('#faisal-tab-us').removeClass('selected');
				jQuery('#faisal-tab-major').removeClass('selected');
				jQuery(this).addClass('selected');
				jQuery('#grid-faisal-tab-us').hide();
				jQuery('#grid-faisal-tab-uk').show();
				jQuery('#grid-faisal-tab-major').hide();
			});
	}

	// Major International Extremists
	if (document.querySelector('#faisal-tab-major')) {
		jQuery(once('major','#faisal-tab-major'))
			.click(function (e) {
				e.preventDefault();
				jQuery('.view-display-id-block_major').triggerHandler('RefreshView');
				jQuery('#faisal-tab-us').removeClass('selected');
				jQuery('#faisal-tab-uk').removeClass('selected');
				jQuery(this).addClass('selected');
				jQuery('#grid-faisal-tab-major').show();
				jQuery('#grid-faisal-tab-us').hide();
				jQuery('#grid-faisal-tab-uk').hide();
			});
	}
});
